import React, { useMemo } from 'react';
import { Stack } from '@moda/om';
import { noop } from '@moda/portal-stanchions';
import { TrunkshowListingPageFragment } from '../../generated/types';
import { TRUNKSHOW_SORT_OPTIONS } from '../../constants';
import { usePLPParams } from '../../hooks/usePLPParams';
import { GridSortByDropdown } from '../GridPeripherals/GridSortByDropdown';
import { SidebarLayout, Sidebar, Content } from '../SidebarLayout';
import { PageFilter, PageFilterClear } from '../PageFilter';
import { GridItemCount } from '../GridPeripherals/GridItemCount';
import { createTrunkshowCategoryTree } from './createTrunkshowCategoryTree';

import './TrunkshowListingDesktop.scss';

interface Props {
  queryResult: TrunkshowListingPageFragment;
  children?: React.ReactNode;
}

export const TrunkshowListingDesktop: React.FC<Props> = ({ queryResult, children }) => {
  const { currentSort, changeSort } = usePLPParams(TRUNKSHOW_SORT_OPTIONS);

  const categoryTree = useMemo(() => createTrunkshowCategoryTree(queryResult), [queryResult]);

  return (
    <Stack className="TrunkshowListingDesktop" space={5}>
      <Stack space={4} direction="horizontal" justifyContent="flex-end">
        <GridItemCount
          className="TrunkshowListingDesktop__count"
          count={queryResult.trunkshows.edges.length}
        />
        <GridSortByDropdown
          availableSorts={TRUNKSHOW_SORT_OPTIONS}
          currentSort={currentSort}
          onSortByChange={changeSort}
        />
      </Stack>
      <SidebarLayout>
        <Sidebar>
          <PageFilter
            attributes={[]}
            availability={null}
            categoryTree={categoryTree}
            colors={[]}
            designers={queryResult.designers || []}
            saleTags={[]}
            sizes={[]}
            showPriceFilter={false}
            onClose={noop}
          />
        </Sidebar>
        <Content>
          <Stack space={3}>
            <PageFilterClear
              attributes={[]}
              designers={queryResult.designers || []}
              sizes={[]}
              categoryTree={categoryTree}
            />
            {children}
          </Stack>
        </Content>
      </SidebarLayout>
    </Stack>
  );
};
